import { createFileRoute } from '@tanstack/react-router';
import { SupplierBillsPage } from '@/features/purchasing/SupplierBillsWorkspace';
export const Route = createFileRoute('/_dashboard/dashboard/purchasing/bills')({ component: Page });
function Page() {
  const { billId, orderId } = Route.useSearch();
  return <SupplierBillsPage billId={billId} orderId={orderId} />;
}
